/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'

import { zIndex } from '../../components/css'
import { media } from '../../components/Responsive'
import React from 'react'

interface SearchContainerProps {
  children: React.ReactNode
  displayContents: boolean
  isTeamOrSchedulePage?: boolean
}

const SearchContainer = React.forwardRef<HTMLDivElement, SearchContainerProps>(
  ({ children, displayContents }, ref) => {
    return (
      <div
        ref={ref}
        className={displayContents ? 'active' : ''}
        css={css`
          position: fixed;
          left: 50%;
          top: 52px; /* Position below header and search input */
          transform: translateX(-50%);
          width: 600px;
          height: 600px;
          background: ${'#293241'};
          border-radius: 8px;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
          z-index: ${zIndex.base + 100};
          opacity: ${displayContents ? 1 : 0};
          transform: ${displayContents
            ? 'translateX(-50%) translateY(0)'
            : 'translateX(-50%) translateY(-8px)'};
          transition: opacity 0.2s ease, transform 0.2s ease;
          pointer-events: ${displayContents ? 'auto' : 'none'};
          display: ${displayContents ? 'flex' : 'none'};
          flex-direction: column;
          overflow: hidden;

          ${(media as any).mobile} {
            width: calc(100vw - 32px);
            max-height: calc(100vh - 120px);
            left: 50%;
            top: 48px;
          }
        `}
      >
        {children}
      </div>
    )
  }
)

export default SearchContainer
